module.exports = __webpack_public_path__ + "assets/img/dapnet-logo.f6092f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dapnet-logo.png
// module id = 565
// module chunks = 1